module.exports = __webpack_public_path__ + "static/media/img107_R.7dae6216.jpg";